export const baseApiUrl = process.env.VUE_APP_BASE_API_URL

export default { baseApiUrl }
